import { render, staticRenderFns } from "./feature-attributes.vue?vue&type=template&id=71519688&"
import script from "./feature-attributes.vue?vue&type=script&lang=js&"
export * from "./feature-attributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports